































































































import {Component, Prop, Model} from 'vue-property-decorator';
import CommonVue from '../models/commonVue';
import {BusEvent} from '@/models/bus';

import Modal from '@/components/Modal.vue';
import EditIcon from '../components/icons/EditIcon.vue';
import VersionDict from "@/api/versionDict";
import DropDownText from "@/components/DropDownText.vue";

@Component({
    components: {
        'modal': Modal,
        'edit-icon': EditIcon,
        'drop-down-text': DropDownText,
    },
})
export default class FieldVersionDicts extends CommonVue {
    @Model('update') public version_dict_list!: VersionDict[];
    @Prop({type: Boolean, default: false}) public disabled?: boolean;

    public version_dict: VersionDict = null;
    public isNewElement: boolean = false;
    public showModal: boolean = false;

    public platformOptions = ['android', 'ios'];
    public platformPresentation = ['Android', 'iOS'];

    // noinspection JSMethodCanBeStatic
    public edit(element: VersionDict) {
        this.version_dict = element;
        this.isNewElement = false;
        this.showModal = true;
    }

    public newVersionDict() {
        this.version_dict = new VersionDict();
        this.isNewElement = true;
        this.showModal = true;
    }

    public saveClicked() {
        if (!this.version_dict) {
            return;
        }

        this.busy = true;

        try {
            if (this.isNewElement) {
                this.version_dict_list.push(this.version_dict);
            }
            this.busy = false;
            this.showModal = false;
        } catch (e) {
            this.busy = false;
            this.$bus.$emit(BusEvent.ERROR, 'Could not save reference alignment', e);
        }
    }

    public deleteClicked() {
        const newList = this.version_dict_list.filter((value) => {
            return value !== this.version_dict;
        });

        this.$emit('update', newList);
        this.showModal = false;
    }

}

